import type { ReactNode } from 'react';
import { TbBrandFacebook, TbBrandTwitter, TbBrandWhatsapp, TbMail } from 'react-icons/tb';
import type { SocialShareButtonType } from './types';

export const BUTTON_COLOR: Record<SocialShareButtonType, string> = {
  facebook: '#3b5998',
  twitter: '#00aced',
  whatsapp: '#25d366',
  email: '#7f7f7f',
};

export const BUTTON_ICON: Record<SocialShareButtonType, ReactNode> = {
  facebook: <TbBrandFacebook />,
  twitter: <TbBrandTwitter />,
  whatsapp: <TbBrandWhatsapp />,
  email: <TbMail />,
};
